import { FunctionComponent, memo, useContext } from "react";
import Modal, { ModalContent, ModalHeader, useModal } from "@edgetier/modal";
import { EllipsisMenuContext, EllipsisMenuItem } from "@edgetier/client-components";
import { faPencil, faPlus } from "@fortawesome/pro-solid-svg-icons";
import { Button } from "@edgetier/components";
import { IProps } from "./add-role-action.types";
import "./add-role-action.scss";

/**
 * Display a button or a menu action, that opens a modal window containing a form to create or update a role;
 * @param props.actionLabel     Label showed in the header or button for an action
 * @param props.children        Child components
 * @param props.isButton        Show a button if true or a menu action otherwise
 */
const AddRoleAction: FunctionComponent<IProps> = ({ children, actionLabel, isButton }) => {
    const { lockOpen, unlock } = useContext(EllipsisMenuContext);
    const { openModal, closeModal, modalProps } = useModal({ onCloseModal: unlock });

    return (
        <>
            <Modal {...modalProps}>
                <ModalHeader>
                    <h2>{actionLabel}</h2>
                </ModalHeader>
                <ModalContent>{typeof children === "function" ? children({ closeModal }) : children}</ModalContent>
            </Modal>

            {typeof isButton === "boolean" && isButton ? (
                <Button icon={faPlus} type="button" onClick={openModal} styleName="positive">
                    {actionLabel}
                </Button>
            ) : (
                <EllipsisMenuItem
                    closeAfterClick={false}
                    icon={faPencil}
                    onClick={() => {
                        lockOpen();
                        openModal();
                    }}
                >
                    Edit
                </EllipsisMenuItem>
            )}
        </>
    );
};

export default memo(AddRoleAction);
